var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "AddFriendBtn" }, [
    _c(
      "button",
      {
        staticClass: "feed__icon",
        class: { active: _vm.isFriend },
        attrs: { disabled: _vm.loading },
        on: { click: _vm.addFriend }
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "spinner-border" })
          : _vm.isFriend
          ? _c("img", {
              attrs: {
                src: require("@assets/imgs/exchange/connect_confirmed.png"),
                alt: "Connecteds"
              }
            })
          : _vm.isRequested
          ? _c("img", {
              staticClass: "requested",
              attrs: {
                src: require("@assets/imgs/exchange/connect.png"),
                alt: "Connect Request Sent"
              }
            })
          : _c("img", {
              attrs: {
                src: require("@assets/imgs/exchange/connect.png"),
                alt: "Connect"
              }
            }),
        _vm._v(" "),
        !_vm.short ? _c("span", [_vm._v(_vm._s(_vm.btnText))]) : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }